import { css } from '@/styled-system/css';

// HotPads overrides colors.Tabs.default.bg.tab.* in the theme, but
// Constellation Tabs 10.18 still paints default tab fills and edge fades
// with bg.action.neutral.*. Bridge scoped tab instances back to the themed tokens.
export const constellationTabBackgroundOverride = css.raw({
  '& [data-c11n-component="Tabs.Tab"]': {
    backgroundColor: 'Tabs.default.bg.tab.default',
  },
  '& [data-c11n-component="Tabs.Tab"]::after': {
    background:
      'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.Tabs.default.bg.tab.default} 75%, {colors.Tabs.default.bg.tab.default})',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:hover, [data-hover])': {
    backgroundColor: 'Tabs.default.bg.tab.hover',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:hover, [data-hover])::after': {
    background:
      'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.Tabs.default.bg.tab.hover} 75%, {colors.Tabs.default.bg.tab.hover})',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:active, [data-active])': {
    backgroundColor: 'Tabs.default.bg.tab.pressed',
  },
  '& [data-c11n-component="Tabs.Tab"]:is(:active, [data-active])::after': {
    background:
      'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.Tabs.default.bg.tab.pressed} 75%, {colors.Tabs.default.bg.tab.pressed})',
  },
  '& [data-c11n-component="Tabs.Tab"][aria-selected="true"]': {
    backgroundColor: 'Tabs.default.bg.tab.active',
  },
  '& [data-c11n-component="Tabs.Tab"][aria-selected="true"]::after': {
    background:
      'linear-gradient(90deg, {colors.bg.invisible} 0%, {colors.Tabs.default.bg.tab.active} 75%, {colors.Tabs.default.bg.tab.active})',
  },
});
